import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/home-page/home-page.component').then(m => m.HomePageComponent),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
